module.exports = "/assets/js/5277da943b8bb6041b310b0e6acec07c.svg";